"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = Icon;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
/**
 * Render a Material Design Icon, used by RegularIcon and OutlinedIcon
 * @param icon Note: this param is a string and does not provide type hints
 * @param filled
 * @param className
 * @param rest
 * @constructor
 */
function Icon({ icon, filled, className, ...rest }) {
    return (react_1.default.createElement("span", { className: (0, clsx_1.default)([
            filled ? 'material-icons' : 'material-icons-outlined',
            className,
        ]), "data-testid": `icon-${icon}`, ...rest }, icon));
}
